import { render, staticRenderFns } from "./AddOrg.vue?vue&type=template&id=30eaf526"
import script from "./AddOrg.vue?vue&type=script&lang=js"
export * from "./AddOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports